// sessionsNeeded: completed training sessions required to unlock the badge —
// starter badge after session 1, then one every 5 sessions (Tabita/Barbara/Niko, 2026-08-24).
export const TRAINING_BUDGES = [
  {
    path: './assets/training-badges/60points reached (Newbie).png',
    sessionsNeeded: 1,
    reached: false,
    name: 'BADGES_NAMES.FIRST'
  },
  {
    path: './assets/training-badges/600points reached (Beginner).png',
    sessionsNeeded: 5,
    reached: false,
    name: 'BADGES_NAMES.SECOND'
  },
  {
    path: './assets/training-badges/1200points reached (Junior).png',
    sessionsNeeded: 10,
    reached: false,
    name: 'BADGES_NAMES.THIRD'
  },
  {
    path: './assets/training-badges/3600points reached and add to profile picture (Experienced).png',
    sessionsNeeded: 15,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.FOURTH'
  },
  {
    path: './assets/training-badges/7200points reached (Advanced).png',
    sessionsNeeded: 20,
    name: 'BADGES_NAMES.FIVE'
  },
  {
    path: './assets/training-badges/10800points reached and add to profile picture (Expert).png',
    sessionsNeeded: 25,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.SIX'
  },
  {
    path: './assets/training-badges/14400points reached (Professional).png',
    sessionsNeeded: 30,
    reached: false,
    name: 'BADGES_NAMES.SEVEN'
  },
  {
    path: './assets/training-badges/18000points reached (Worldclass).png',
    sessionsNeeded: 35,
    reached: false,
    name: 'BADGES_NAMES.EIGHT'
  },
  {
    path: './assets/training-badges/21600points reached and add around profile picture (Superbrain).png',
    sessionsNeeded: 40,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.NINE'
  },
  {
    path: './assets/training-badges/mastermind_43200points.png',
    sessionsNeeded: 45,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.MASTERMIND'
  },
  {
    path: './assets/training-badges/grandmaster_86400points.png',
    sessionsNeeded: 50,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.GRANDMASTER'
  },
  {
    path: './assets/training-badges/zenith_150000points.png',
    sessionsNeeded: 55,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.ZENITH'
  },
  {
    path: './assets/training-badges/cognitive- titan_250000points.png',
    sessionsNeeded: 60,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.TITAN'
  },
  {
    path: './assets/training-badges/legend_100000points.png',
    sessionsNeeded: 65,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.FOCUS'
  },
  {
    path: './assets/training-badges/champion_50000points.png',
    sessionsNeeded: 70,
    addToProfile: true,
    reached: false,
    name: 'BADGES_NAMES.LEGEND'
  },
]
